import { Route, Routes } from 'react-router';
import Signin from './signin';
import Redirect from './redirect';
import ForgotPassword from './forgot-password';
import UpdatePassword from './update-password';
import EidpForm from './eidp-form';
import GoogleAccounts from 'src/sections/onboard/google-accounts';
import ResetPassword from './reset-password';


export default function Auth() {
  return (
    <Routes>
      <Route path="/auth/signin" element={<Signin />} />
      <Route path="/auth/forgot" element={<ForgotPassword />} />
      <Route path="/auth/password" element={<UpdatePassword />} />
      <Route path="/auth/reset_password" element={<ResetPassword />} />
      <Route path="/auth/eidp" element={<EidpForm />} />
      <Route path="/onboard/success" element={<GoogleAccounts />} />

      <Route path="*" element={<Redirect />} />
    </Routes>
  );
}
